import React, { FC } from 'react';
import { Button, LottieIcon, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';
import { Link, useRoute } from 'react-router5';
import { FEED } from '$shared/constants/pages';

export const OnboardingPlaceholder: FC<{ centered?: boolean }> = ({ centered }) => {
  const t = useTranslator();
  const { route } = useRoute();
  const activeTab = route.params?.section ?? 'following';

  if (activeTab === 'search') {
    return <Placeholder>{t('feed_search_empty')}</Placeholder>;
  }

  return (
    <Placeholder
      icon={<LottieIcon name="news" />}
      iconSize={120}
      centered={centered}
      title={t('feed_onboarding_title')}
      actions={
        <Link routeName={FEED} routeParams={{ section: 'smart' }}>
          <Button size="small">{t('feed_show_peoples')}</Button>
        </Link>
      }
    >
      {t('feed_onboarding_caption')}
    </Placeholder>
  );
};
